import React from "react";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";

export function InfoCard(props) {
  const {Icon, color, children} = props;

  return (
    <Card className={`bg-light-${color} flex-grow-1 justify-content-center`}>
      <CardBody className={`p-7 text-${color}`}>
        {Icon && <Icon className={`mb-5 text-${color}`} style={{fontSize: 35}} />}
        {children}
      </CardBody>
    </Card>
  )
}
